var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VApp',[_c('VContent',[_c('VContainer',{attrs:{"fluid":"","fill-height":""}},[_c('VLayout',{attrs:{"align-center":"","justify-center":""}},[_c('VFlex',{attrs:{"md4":"","sm8":"","xs12":""}},[_c('RegistrationCard')],1)],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }